import React, { useContext } from "react";
import classes from "./index.module.scss";
import { Breadcrumb } from "antd";
import { Link, useHistory } from "react-router-dom";
import classNames from "classnames";
import useDeviceType from "Utils/useDeviceType";
import { CourseContext } from "../../Store";
import { SubLayout } from "../../../../components/Layouts/SubLayout";
import { SubLayoutHeader } from "../../../../components/Layouts/SubLayout/Component/SubLayoutHeader";
interface IProps {
    courseNo: string;
    courseSeq: string;
    weekTimeId: string;
}
interface DetailLayoutProps {
    children: React.ReactNode;
    breadcrumb: string;
    mobileHeaderExtra?: React.ReactNode;
    title?: string;
}

export default function DetailLayout({
    children,
    breadcrumb,
    title = "课程内容",
    mobileHeaderExtra
}: DetailLayoutProps) {
    const { isPC } = useDeviceType();
    const history = useHistory();
    const { basename } = useContext(CourseContext);

    return (
        <SubLayout className={classNames(classes.root, "PopupContainer")}>
            <SubLayoutHeader title={title} extra={mobileHeaderExtra} />

            <div className={classes.main}>
                {isPC && (
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item>
                            <Link to="/">首页</Link>
                        </Breadcrumb.Item>

                        <Breadcrumb.Item
                            onClick={() =>
                                history.push(`${basename}/courseware`)
                            }>
                            <a href="#">课程内容</a>
                        </Breadcrumb.Item>

                        <Breadcrumb.Item>{breadcrumb}</Breadcrumb.Item>
                    </Breadcrumb>
                )}

                <div className={classes.body}>{children}</div>
            </div>
        </SubLayout>
    );
}
